import React, { useEffect, useState } from 'react';
import { bool, string } from 'prop-types';
import { clickEvent, loadEvent } from './publisher';
import { loadEstimatorScript } from './utils';
import './intro-offer.style.scss';

export const IntroOffer = ({ fileVersion, mobile }) => {
  const [applyNowUrl, setApplyNowUrl] = useState(null);

  function getApplyNowUrl(isMobile) {
    const estimator = window && window.THD ? (window.THD || {}).PaymentEstimator : null;
    const { defaultApplynowLinks } = estimator || {};
    const links = defaultApplynowLinks ? defaultApplynowLinks('pip') : null;
    if (!links) {
      return;
    }

    const url = isMobile ? links.mobileUrl : links.desktopUrl;
    setApplyNowUrl(url);
  }

  useEffect(() => {
    loadEvent('plcc');
    loadEstimatorScript(fileVersion, getApplyNowUrl, mobile);
  }, []);

  if (!applyNowUrl) {
    return null;
  }

  return (
    <div className="buybox-credit-promo-message">
      <div className="credit-card-icon">Truck</div>
      <div>
        <div><strong>Save up to $100<span className="credit-terms-icon">&#9826;</span></strong> on
          your qualifying purchase.
        </div>
        <a
          href={applyNowUrl}
          className="u__default-link"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => clickEvent('plcc')}
        >
          Apply for a Home Depot Consumer Card
        </a>
      </div>
    </div>
  );

};

IntroOffer.displayName = 'IntroOffer';

IntroOffer.propTypes = {
  mobile: bool.isRequired,
  fileVersion: string.isRequired
};
